import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, EditorDefinition, Expose, IsEmail, IdItemModel, ItemModelDefinition, MinLength, Trim, ItemModelProp, ModelId } from '@core/shared/model';
import { FeedbackRestraints } from './feedback.restraints';
let FeedbackItem = /*#__PURE__*/(() => {
  let FeedbackItem = class FeedbackItem extends IdItemModel {
    toString() {
      return "Feedback by " + this.name;
    }
  };
  __decorate([MinLength(2), Expose(), Trim(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], FeedbackItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], FeedbackItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], FeedbackItem.prototype, "ownerId", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], FeedbackItem.prototype, "creationDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], FeedbackItem.prototype, "url", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], FeedbackItem.prototype, "userAgent", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], FeedbackItem.prototype, "version", void 0);
  __decorate([IsEmail(undefined), Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], FeedbackItem.prototype, "email", void 0);
  __decorate([MinLength(10), Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], FeedbackItem.prototype, "message", void 0);
  FeedbackItem = __decorate([EditorDefinition({
    name: true,
    email: true,
    message: true,
    url: 'readonly',
    userAgent: 'readonly'
  }, {
    useCrudEndpoint: 'public'
  }), EditorDefinition('admin', ['name', 'email', 'message'], {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    public: '/feedback',
    admin: '/admin/feedback'
  }), UseRestraints(FeedbackRestraints), ItemModelDefinition({
    texts: {
      item: 'Feedback-Item',
      items: 'Feedback-Items'
    }
  }), ModelId("FeedbackItem") // auto-generated by generate-model-ids
  ], FeedbackItem);
  return FeedbackItem;
})();
export { FeedbackItem };